import { createReducer } from 'redux-act';
import actions from '../actions/assetsManagementActions';

const initialState = {
    addAssetsPending: false,
    addAssetsRes: null,
    addAssetsError: null,

    getAllAssetsPending: false,
    getAllAssetsRes: null,
    getAllAssetsError: null,

    getAssetsPending: false,
    getAssetsRes: null,
    getAssetsError: null,

    updateAssetsPending: false,
    updateAssetsRes: null,
    updateAssetsError: null,

    deleteAssetsPending: false,
    deleteAssetsRes: null,
    deleteAssetsError: null,

    assetsInStockPending: false,
    assetsInStockRes: null,
    assetsInStockError: null,

    assignAssetToEmployeePending: false,
    assignAssetToEmployeeRes: null,
    assignAssetToEmployeeError: null,

    getAssignAssetPending: false,
    getAssignAssetRes: null,
    getAssignAssetError: null,

    releaseAssetsPending: false,
    releaseAssetsRes: null,
    releaseAssetsError: null,

    assetUndertakingPending: false,
    assetUndertakingRes: null,
    assetUndertakingError: null,

    getAssetUndertakingPending: false,
    getAssetUndertakingRes: null,
    getAssetUndertakingError: null,

    assetRequestPending: false,
    assetRequestRes: null,
    assetRequestError: null,

    getAssetRequestDataPending: false,
    getAssetRequestDataRes: null,
    getAssetRequestDataError: null,

    assignedAssetPending: false,
    assignedAssetRes: null,
    assignedAssetError: null,

    myAssetPending: false,
    myAssetRes: null,
    myAssetError: null,

    getAssetApprovalPending: false,
    getAssetApprovalRes: null,
    getAssetApprovalError: null,

    approveAssetRequestPending: false,
    approveAssetRequestRes: null,
    approveAssetRequestError: null,


    getUnderTakingPending: false,
    getUnderTakingRes: null,
    getUnderTakingError: null,

    assetSummaryPending: false,
    assetSummaryRes: null,
    assetSummaryError: null,


    cancelAssetRequestPending: false,
    cancelAssetRequestRes: null,
    cancelAssetRequestError: null,

    teamAssetPending: false,
    teamAssetRes: null,
    teamAssetError: null,

};
/* Add Assets Reducers */
const handleAddAssetsRequest = state => {
    return {
        ...state,
        ...{
            addAssetsPending: true,
            addAssetsRes: null,
            addAssetsError: null,
        },
    };
};
const handleAddAssetsSuccess = (state, payload) => {
    return {
        ...state,
        ...{
            addAssetsPending: false,
            addAssetsRes: payload,
            addAssetsError: null,
        },
    };
};
const handleAddAssetsError = (state, payload) => ({
    ...state,
    ...{
        addAssetsPending: false,
        addAssetsRes: null,
        addAssetsError: payload,
    },
});


/* Get Assets Reducers */
const handleGetAllAssetsListRequest = state1 => {
    return {
        ...state1,
        ...{
            getAllAssetsPending: true,
            getAllAssetsRes: null,
            getAllAssetsError: null,
        },
    };
};
const handleGetAllAssetsListSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            getAllAssetsPending: false,
            getAllAssetsRes: payload,
            getAllAssetsError: null,
        },
    };
};
const handleGetAllAssetsListError = (state1, payload) => ({
    ...state1,
    ...{
        getAllAssetsPending: false,
        getAllAssetsRes: null,
        getAllAssetsError: payload,
    },
});


/* Get Assets by Department Reducers */
const handleGetAssetsRequest = state1 => {
    return {
        ...state1,
        ...{
            getAssetsPending: true,
            getAssetsRes: null,
            getAssetsError: null,
        },
    };
};
const handleGetAssetsSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            getAssetsPending: false,
            getAssetsRes: payload,
            getAssetsError: null,
        },
    };
};
const handleGetAssetsError = (state1, payload) => ({
    ...state1,
    ...{
        getAssetsPending: false,
        getAssetsRes: null,
        getAssetsError: payload,
    },
});

/* Update Assets Reducers*/
const handleUpdateAssetsRequest = state1 => {
    return {
        ...state1,
        ...{
            updateAssetsPending: true,
            updateAssetsRes: null,
            updateAssetsError: null,
        },
    };
};
const handleUpdateAssetsSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            updateAssetsPending: false,
            updateAssetsRes: payload,
            updateAssetsError: null,
        },
    };
};
const handleUpdateAssetsError = (state1, payload) => ({
    ...state1,
    ...{
        updateAssetsPending: false,
        updateAssetsRes: null,
        updateAssetsError: payload,
    },
});

/* Delete Assets Reducers*/
const handleDeleteAssetsRequest = state1 => {
    return {
        ...state1,
        ...{
            deleteAssetsPending: true,
            deleteAssetsRes: null,
            deleteAssetsError: null,
        },
    };
};
const handleDeleteAssetsSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            deleteAssetsPending: false,
            deleteAssetsRes: payload,
            deleteAssetsError: null,
        },
    };
};
const handleDeleteAssetsError = (state1, payload) => ({
    ...state1,
    ...{
        deleteAssetsPending: false,
        deleteAssetsRes: null,
        deleteAssetsError: payload,
    },
});

/* Assets In Stock Reducers*/
const handleAssetsInStockRequest = state1 => {
    return {
        ...state1,
        ...{
            assetsInStockPending: true,
            assetsInStockRes: null,
            assetsInStockError: null,
        },
    };
};
const handleAssetsInStockSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            assetsInStockPending: false,
            assetsInStockRes: payload,
            assetsInStockError: null,
        },
    };
};
const handleAssetsInStockError = (state1, payload) => ({
    ...state1,
    ...{
        assetsInStockPending: false,
        assetsInStockRes: null,
        assetsInStockError: payload,
    },
});

/* Assign Asset To Employee Reducers*/
const handleAssignAssetToEmployeeRequest = state1 => {
    return {
        ...state1,
        ...{
            assignAssetToEmployeePending: true,
            assignAssetToEmployeeRes: null,
            assignAssetToEmployeeError: null,
        },
    };
};
const handleAssignAssetToEmployeeSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            assignAssetToEmployeePending: false,
            assignAssetToEmployeeRes: payload,
            assignAssetToEmployeeError: null,
        },
    };
};
const handleAssignAssetToEmployeeError = (state1, payload) => ({
    ...state1,
    ...{
        assignAssetToEmployeePending: false,
        assignAssetToEmployeeRes: null,
        assignAssetToEmployeeError: payload,
    },
});

/* Get Assign Asset Reducers*/
const handleGetAssignAssetRequest = state1 => {
    return {
        ...state1,
        ...{
            getAssignAssetPending: true,
            getAssignAssetRes: null,
            getAssignAssetError: null,
        },
    };
};
const handleGetAssignAssetSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            getAssignAssetPending: false,
            getAssignAssetRes: payload,
            getAssignAssetError: null,
        },
    };
};
const handleGetAssignAssetError = (state1, payload) => ({
    ...state1,
    ...{
        getAssignAssetPending: false,
        getAssignAssetRes: null,
        getAssignAssetError: payload,
    },
});


/* Release Assets Reducers*/
const handleReleaseAssetsRequest = state1 => {
    return {
        ...state1,
        ...{
            releaseAssetsPending: true,
            releaseAssetsRes: null,
            releaseAssetsError: null,
        },
    };
};
const handleReleaseAssetsSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            releaseAssetsPending: false,
            releaseAssetsRes: payload,
            releaseAssetsError: null,
        },
    };
};
const handleReleaseAssetsError = (state1, payload) => ({
    ...state1,
    ...{
        releaseAssetsPending: false,
        releaseAssetsRes: null,
        releaseAssetsError: payload,
    },
});

/* Release Assets Reducers*/
const handleAssetUndertakingRequest = state1 => {
    return {
        ...state1,
        ...{
            assetUndertakingPending: true,
            assetUndertakingRes: null,
            assetUndertakingError: null,
        },
    };
};
const handleAssetUndertakingSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            assetUndertakingPending: false,
            assetUndertakingRes: payload,
            assetUndertakingError: null,
        },
    };
};
const handleAssetUndertakingError = (state1, payload) => ({
    ...state1,
    ...{
        assetUndertakingPending: false,
        assetUndertakingRes: null,
        assetUndertakingError: payload,
    },
});


/* Get Asset Undertaking Reducers*/
const handleGetAssetUndertakingRequest = state1 => {
    return {
        ...state1,
        ...{
            getAssetUndertakingPending: true,
            getAssetUndertakingRes: null,
            getAssetUndertakingError: null,
        },
    };
};
const handleGetAssetUndertakingSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            getAssetUndertakingPending: false,
            getAssetUndertakingRes: payload,
            getAssetUndertakingError: null,
        },
    };
};
const handleGetAssetUndertakingError = (state1, payload) => ({
    ...state1,
    ...{
        getAssetUndertakingPending: false,
        getAssetUndertakingRes: null,
        getAssetUndertakingError: payload,
    },
});


/* Asset Request Reducers*/
const handleAssetRequestRequest = state1 => {
    return {
        ...state1,
        ...{
            assetRequestPending: true,
            assetRequestRes: null,
            assetRequestError: null,
        },
    };
};
const handleAssetRequestSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            assetRequestPending: false,
            assetRequestRes: payload,
            assetRequestError: null,
        },
    };
};
const handleAssetRequestError = (state1, payload) => ({
    ...state1,
    ...{
        assetRequestPending: false,
        assetRequestRes: null,
        assetRequestError: payload,
    },
});


/* Get Asset Request Data Reducers*/
const handleGetAssetRequestDataRequest = state1 => {
    return {
        ...state1,
        ...{
            getAssetRequestDataPending: true,
            getAssetRequestDataRes: null,
            getAssetRequestDataError: null,
        },
    };
};
const handleGetAssetRequestDataSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            getAssetRequestDataPending: false,
            getAssetRequestDataRes: payload,
            getAssetRequestDataError: null,
        },
    };
};
const handleGetAssetRequestDataError = (state1, payload) => ({
    ...state1,
    ...{
        getAssetRequestDataPending: false,
        getAssetRequestDataRes: null,
        getAssetRequestDataError: payload,
    },
});

/* Get Asset Request Data Reducers*/
const handleAssignedAssetRequest = state1 => {
    return {
        ...state1,
        ...{
            assignedAssetPending: true,
            assignedAssetRes: null,
            assignedAssetError: null,
        },
    };
};
const handleAssignedAssetSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            assignedAssetPending: false,
            assignedAssetRes: payload,
            assignedAssetError: null,
        },
    };
};
const handleAssignedAssetError = (state1, payload) => ({
    ...state1,
    ...{
        assignedAssetPending: false,
        assignedAssetRes: null,
        assignedAssetError: payload,
    },
});


/* Get Asset Request Data Reducers*/
const handleMyAssetRequest = state1 => {
    return {
        ...state1,
        ...{
            myAssetPending: true,
            myAssetRes: null,
            myAssetError: null,
        },
    };
};
const handleMyAssetSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            myAssetPending: false,
            myAssetRes: payload,
            myAssetError: null,
        },
    };
};
const handleMyAssetError = (state1, payload) => ({
    ...state1,
    ...{
        myAssetPending: false,
        myAssetRes: null,
        myAssetError: payload,
    },
});

/* Get Asset Request Data Reducers*/
const handleGetAssetApprovalRequest = state1 => {
    return {
        ...state1,
        ...{
            getAssetApprovalPending: true,
            getAssetApprovalRes: null,
            getAssetApprovalError: null,
        },
    };
};
const handleGetAssetApprovalSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            getAssetApprovalPending: false,
            getAssetApprovalRes: payload,
            getAssetApprovalError: null,
        },
    };
};
const handleGetAssetApprovalError = (state1, payload) => ({
    ...state1,
    ...{
        getAssetApprovalPending: false,
        getAssetApprovalRes: null,
        getAssetApprovalError: payload,
    },
});


/* Get Asset Request Data Reducers*/
const handleApproveAssetRequestRequest = state1 => {
    return {
        ...state1,
        ...{
            approveAssetRequestPending: true,
            approveAssetRequestRes: null,
            approveAssetRequestError: null,
        },
    };
};
const handleApproveAssetRequestSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            approveAssetRequestPending: false,
            approveAssetRequestRes: payload,
            approveAssetRequestError: null,
        },
    };
};
const handleApproveAssetRequestError = (state1, payload) => ({
    ...state1,
    ...{
        approveAssetRequestPending: false,
        approveAssetRequestRes: null,
        approveAssetRequestError: payload,
    },
});



/* Get Asset Request Data Reducers*/
const handleGetUnderTakingRequest = state1 => {
    return {
        ...state1,
        ...{
            getUnderTakingPending: true,
            getUnderTakingRes: null,
            getUnderTakingError: null,
        },
    };
};
const handleGetUnderTakingSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            getUnderTakingPending: false,
            getUnderTakingRes: payload,
            getUnderTakingError: null,
        },
    };
};
const handleGetUnderTakingError = (state1, payload) => ({
    ...state1,
    ...{
        getUnderTakingPending: false,
        getUnderTakingRes: null,
        getUnderTakingError: payload,
    },
});


/* Get Asset Request Data Reducers*/
const handleAssetSummaryRequest = state1 => {
    return {
        ...state1,
        ...{
            assetSummaryPending: true,
            assetSummaryRes: null,
            assetSummaryError: null,
        },
    };
};
const handleAssetSummarySuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            assetSummaryPending: false,
            assetSummaryRes: payload,
            assetSummaryError: null,
        },
    };
};
const handleAssetSummaryError = (state1, payload) => ({
    ...state1,
    ...{
        assetSummaryPending: false,
        assetSummaryRes: null,
        assetSummaryError: payload,
    },
});

/* Get Asset Request Data Reducers*/
const handleCancelAssetRequestRequest = state1 => {
    return {
        ...state1,
        ...{
            cancelAssetRequestPending: true,
            cancelAssetRequestRes: null,
            cancelAssetRequestError: null,
        },
    };
};
const handleCancelAssetRequestSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            cancelAssetRequestPending: false,
            cancelAssetRequestRes: payload,
            cancelAssetRequestError: null,
        },
    };
};
const handleCancelAssetRequestError = (state1, payload) => ({
    ...state1,
    ...{
        cancelAssetRequestPending: false,
        cancelAssetRequestRes: null,
        cancelAssetRequestError: payload,
    },
});


/* Get Asset Request Data Reducers*/
const handleTeamAssetRequest = state1 => {
    return {
        ...state1,
        ...{
            teamAssetPending: true,
            teamAssetRes: null,
            teamAssetError: null,
        },
    };
};
const handleTeamAssetSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            teamAssetPending: false,
            teamAssetRes: payload,
            teamAssetError: null,
        },
    };
};
const handleTeamAssetError = (state1, payload) => ({
    ...state1,
    ...{
        teamAssetPending: false,
        teamAssetRes: null,
        teamAssetError: payload,
    },
});




/* Clear Assets Store */
const clearAssetsStore = (state, payload) => {
    switch (payload) {
        case 'HANDLE_CLEAR_ADD_ASSETS_STORE':
            return {
                ...state,
                ...{
                    addAssetsPending: false,
                    addAssetsRes: null,
                    addAssetsError: null,
                },
            };
        case 'HANDLE_CLEAR_UPDATE_ASSETS_STORE':
            return {
                ...state,
                ...{
                    updateAssetsPending: false,
                    updateAssetsRes: null,
                    updateAssetsError: null,
                },
            };
        case 'HANDLE_CLEAR_DELETE_ASSETS_STORE':
            return {
                ...state,
                ...{
                    deleteAssetsPending: false,
                    deleteAssetsRes: null,
                    deleteAssetsError: null,
                },
            };

        case 'HANDLE_CLEAR_ASSIGN_ASSET_TO_EMPLOYEE_STORE':
            return {
                ...state,
                ...{
                    assignAssetToEmployeePending: false,
                    assignAssetToEmployeeRes: null,
                    assignAssetToEmployeeError: null,
                },
            };
        case 'HANDLE_CLEAR_RELEASE_ASSETS_STORE':
            return {
                ...state,
                ...{
                    releaseAssetsPending: false,
                    releaseAssetsRes: null,
                    releaseAssetsError: null,
                },
            };
        case 'HANDLE_CLEAR_ASSET_REQUEST_STORE':
            return {
                ...state,
                ...{
                    assetRequestPending: false,
                    assetRequestRes: null,
                    assetRequestError: null,
                },
            };
        case 'HANDLE_CLEAR_APPROVE_ASSET_REQUEST_STORE':
            return {
                ...state,
                ...{
                    approveAssetRequestPending: false,
                    approveAssetRequestRes: null,
                    approveAssetRequestError: null,
                },
            };
        case 'HANDLE_CLEAR_ASSET_UNDERTAKING_STORE':
            return {
                ...state,
                ...{
                    assetUndertakingPending: false,
                    assetUndertakingRes: null,
                    assetUndertakingError: null,
                },
            };
        case 'HANDLE_CLEAR_CANCEL_ASSET_REQUEST_STORE':
            return {
                ...state,
                ...{
                    cancelAssetRequestPending: false,
                    cancelAssetRequestRes: null,
                    cancelAssetRequestError: null,
                },
            };
        default:
            return state;
    }
};



export default createReducer(
    {
        [actions.addAssetsRequest]: handleAddAssetsRequest,
        [actions.addAssetsSuccess]: handleAddAssetsSuccess,
        [actions.addAssetsError]: handleAddAssetsError,

        [actions.getAllAssetsListRequest]: handleGetAllAssetsListRequest,
        [actions.getAllAssetsListSuccess]: handleGetAllAssetsListSuccess,
        [actions.getAllAssetsListError]: handleGetAllAssetsListError,

        [actions.getAssetsRequest]: handleGetAssetsRequest,
        [actions.getAssetsSuccess]: handleGetAssetsSuccess,
        [actions.getAssetsError]: handleGetAssetsError,

        [actions.updateAssetsRequest]: handleUpdateAssetsRequest,
        [actions.updateAssetsSuccess]: handleUpdateAssetsSuccess,
        [actions.updateAssetsError]: handleUpdateAssetsError,

        [actions.deleteAssetsRequest]: handleDeleteAssetsRequest,
        [actions.deleteAssetsSuccess]: handleDeleteAssetsSuccess,
        [actions.deleteAssetsError]: handleDeleteAssetsError,

        [actions.assetsInStockRequest]: handleAssetsInStockRequest,
        [actions.assetsInStockSuccess]: handleAssetsInStockSuccess,
        [actions.assetsInStockError]: handleAssetsInStockError,

        [actions.assignAssetToEmployeeRequest]: handleAssignAssetToEmployeeRequest,
        [actions.assignAssetToEmployeeSuccess]: handleAssignAssetToEmployeeSuccess,
        [actions.assignAssetToEmployeeError]: handleAssignAssetToEmployeeError,

        [actions.getAssignAssetRequest]: handleGetAssignAssetRequest,
        [actions.getAssignAssetSuccess]: handleGetAssignAssetSuccess,
        [actions.getAssignAssetError]: handleGetAssignAssetError,

        [actions.releaseAssetsRequest]: handleReleaseAssetsRequest,
        [actions.releaseAssetsSuccess]: handleReleaseAssetsSuccess,
        [actions.releaseAssetsError]: handleReleaseAssetsError,

        [actions.assetUndertakingRequest]: handleAssetUndertakingRequest,
        [actions.assetUndertakingSuccess]: handleAssetUndertakingSuccess,
        [actions.assetUndertakingError]: handleAssetUndertakingError,

        [actions.getAssetUndertakingRequest]: handleGetAssetUndertakingRequest,
        [actions.getAssetUndertakingSuccess]: handleGetAssetUndertakingSuccess,
        [actions.getAssetUndertakingError]: handleGetAssetUndertakingError,


        [actions.assetRequestRequest]: handleAssetRequestRequest,
        [actions.assetRequestSuccess]: handleAssetRequestSuccess,
        [actions.assetRequestError]: handleAssetRequestError,

        [actions.getAssetRequestDataRequest]: handleGetAssetRequestDataRequest,
        [actions.getAssetRequestDataSuccess]: handleGetAssetRequestDataSuccess,
        [actions.getAssetRequestDataError]: handleGetAssetRequestDataError,

        [actions.assignedAssetRequest]: handleAssignedAssetRequest,
        [actions.assignedAssetSuccess]: handleAssignedAssetSuccess,
        [actions.assignedAssetError]: handleAssignedAssetError,

        [actions.myAssetRequest]: handleMyAssetRequest,
        [actions.myAssetSuccess]: handleMyAssetSuccess,
        [actions.myAssetError]: handleMyAssetError,

        [actions.getAssetApprovalRequest]: handleGetAssetApprovalRequest,
        [actions.getAssetApprovalSuccess]: handleGetAssetApprovalSuccess,
        [actions.getAssetApprovalError]: handleGetAssetApprovalError,

        [actions.approveAssetRequestRequest]: handleApproveAssetRequestRequest,
        [actions.approveAssetRequestSuccess]: handleApproveAssetRequestSuccess,
        [actions.approveAssetRequestError]: handleApproveAssetRequestError,

        [actions.getUnderTakingRequest]: handleGetUnderTakingRequest,
        [actions.getUnderTakingSuccess]: handleGetUnderTakingSuccess,
        [actions.getUnderTakingError]: handleGetUnderTakingError,

        [actions.assetSummaryRequest]: handleAssetSummaryRequest,
        [actions.assetSummarySuccess]: handleAssetSummarySuccess,
        [actions.assetSummaryError]: handleAssetSummaryError,

        [actions.cancelAssetRequestRequest]: handleCancelAssetRequestRequest,
        [actions.cancelAssetRequestSuccess]: handleCancelAssetRequestSuccess,
        [actions.cancelAssetRequestError]: handleCancelAssetRequestError,
        
        [actions.teamAssetRequest]: handleTeamAssetRequest,
        [actions.teamAssetSuccess]: handleTeamAssetSuccess,
        [actions.teamAssetError]: handleTeamAssetError,


        [actions.handleClearAssetsStore]: clearAssetsStore,
    },
    initialState,
);